import React from 'react';
import { WebsiteDesignProps } from './types';
import { Zap, MessageCircle, Star, BoomBox } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ComicBook: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Hero High";

    return (
        <div className="bg-white min-h-screen font-sans overflow-x-hidden text-black selection:bg-yellow-400">
             {/* Halftone Pattern */}
             <div className="fixed inset-0 pointer-events-none opacity-10" style={{backgroundImage: 'radial-gradient(circle, #000 2px, transparent 2.5px)', backgroundSize: '16px 16px'}}></div>

             <nav className="p-6 bg-blue-600 border-b-4 border-black relative z-20 flex justify-between items-center shadow-[4px_4px_0_0_#000]">
                 <div className="text-4xl font-extrabold text-yellow-400 italic uppercase tracking-tighter drop-shadow-[2px_2px_0_#000] stroke-black" style={{textShadow: '3px 3px 0 #000'}}>
                     {schoolName}
                 </div>
                 <Button className="bg-red-500 hover:bg-red-600 text-white font-black uppercase text-xl border-4 border-black shadow-[4px_4px_0_0_#000] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_0_#000] transition-all rounded-none skew-x-[-10deg]">
                     Join Now!
                 </Button>
             </nav>

             <main className="container mx-auto px-6 py-12 relative z-10">
                 <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                     <div>
                         <div className="relative inline-block mb-8">
                             <div className="bg-white border-4 border-black p-6 rounded-[2rem] rounded-bl-none shadow-[8px_8px_0_0_#000] relative">
                                 <p className="text-2xl font-bold uppercase leading-tight">
                                     Unlock your <br/> <span className="text-red-600">Super Potential!</span>
                                 </p>
                             </div>
                             <div className="absolute -bottom-4 left-0 w-8 h-8 bg-white border-b-4 border-l-4 border-black transform skew-x-12"></div>
                         </div>

                         <h1 className="text-7xl md:text-9xl font-black uppercase leading-[0.85] text-transparent bg-clip-text bg-gradient-to-br from-yellow-400 to-orange-500 drop-shadow-[6px_6px_0_#000] mb-8">
                             POW!<br/>BAM!<br/>LEARN!
                         </h1>

                         <p className="text-xl font-bold bg-yellow-300 inline-block px-4 py-2 border-2 border-black mb-8 rotate-1">
                             The most epic animated curriculum in the universe.
                         </p>
                     </div>

                     <div className="relative">
                          {/* Radial burst behind image */}
                          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-blue-200 z-0" style={{clipPath: 'polygon(20% 0%, 80% 0%, 100% 20%, 100% 80%, 80% 100%, 20% 100%, 0% 80%, 0% 20%)'}}></div>
                          
                          <div className="relative z-10 border-4 border-black bg-white p-2 shadow-[12px_12px_0_0_#000] transform rotate-2 hover:rotate-0 transition-transform duration-300">
                              <img src="https://images.unsplash.com/photo-1510511459019-5dda7724fd87?q=80&w=2070&auto=format&fit=crop" className="w-full h-full grayscale contrast-125 border-2 border-black" alt="Student" />
                              <div className="absolute -top-6 -right-6 bg-red-500 text-white font-black p-4 rounded-full border-4 border-black w-24 h-24 flex items-center justify-center text-center leading-none text-sm shadow-[4px_4px_0_0_#000] rotate-12">
                                  BEST<br/>CLASS<br/>EVER!
                              </div>
                          </div>
                     </div>
                 </div>

                 <div className="mt-24 grid grid-cols-1 md:grid-cols-3 gap-8">
                     {[
                         { icon: Zap, bg: 'bg-yellow-400', title: 'Power Up', desc: 'Gain skills faster than a speeding bullet.' },
                         { icon: Star, bg: 'bg-blue-400', title: 'Top Rank', desc: 'Rise to the top of the leaderboard.' },
                         { icon: BoomBox, bg: 'bg-red-400', title: 'Loud & Proud', desc: 'Express yourself without fear.' },
                     ].map((item, i) => (
                         <div key={i} className={`border-4 border-black p-8 ${item.bg} shadow-[8px_8px_0_0_#000] hover:translate-x-[4px] hover:translate-y-[4px] hover:shadow-[4px_4px_0_0_#000] transition-all cursor-pointer`}>
                             <item.icon size={48} className="mb-4 stroke-[2.5px] drop-shadow-[2px_2px_0_#000]" />
                             <h3 className="text-3xl font-black uppercase italic mb-2 text-white text-shadow-black">{item.title}</h3>
                             <p className="font-bold border-t-2 border-black pt-2">{item.desc}</p>
                         </div>
                     ))}
                 </div>
             </main>
        </div>
    );
};

export default ComicBook;
